var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "singleLineMultiline"
  }, [_vm.itemData.partsType === "payment" ? [_c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_c("a-input", {
    style: {
      width: _vm.itemData.widthSet
    },
    attrs: {
      placeholder: _vm.$t(_vm.itemData.promptText),
      disabled: !_vm.isEdit
    },
    on: {
      blur: _vm.blurFun
    },
    model: {
      value: _vm.formData[_vm.itemData.mark],
      callback: function ($$v) {
        _vm.$set(_vm.formData, _vm.itemData.mark, $$v);
      },
      expression: "formData[itemData.mark]"
    }
  }), _vm._v("   " + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId))) + "   ")], 1)] : _vm._e(), _vm.itemData.partsType === "estimate" ? [_c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_c("a-input", {
    style: {
      width: _vm.itemData.widthSet
    },
    attrs: {
      placeholder: _vm.$t(_vm.itemData.promptText),
      disabled: !_vm.isEdit
    },
    on: {
      blur: _vm.blurFun
    },
    model: {
      value: _vm.formData[_vm.itemData.mark],
      callback: function ($$v) {
        _vm.$set(_vm.formData, _vm.itemData.mark, $$v);
      },
      expression: "formData[itemData.mark]"
    }
  }), _vm._v("   " + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId))) + "   ")], 1)] : _vm._e()], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };